/**
 * Money as the owner portal prints it: whole euros, grouped, symbol last —
 * "3.077 €" in German, "€3,077" in English.
 *
 * Its own module rather than an export from the Payouts page, because the
 * statement dialog and the PDF both need the same rounding. Two formatters
 * would eventually round a 3.076,50 € payout two different ways, and the whole
 * promise of that screen is that the dialog and the document agree.
 *
 * Cents in, because every figure on these surfaces is stored in cents and a
 * euro float would reintroduce the rounding this avoids.
 */
export function formatEuroCents(cents: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}
